import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'
import { ignoreNewLineEmoji } from 'common/variantsUtils'

import { ExperimentInfo } from '../../experimentsPage/interfaces'
import { fetchActivePersonalizedCampaigns, ResponseCampaign } from '../api'
import { personalizationKeys } from '../queryKeys'

const mapExperimentToCard = (experiment: ResponseCampaign): ExperimentInfo => ({
  id: experiment?._id,
  name: ignoreNewLineEmoji(experiment?.name),
  createdDate: experiment?.created?.toString() ?? '',
  lastModified: '',
  owner: `${experiment?.campaignOwner?.fname ?? ''}${' '}${
    experiment?.campaignOwner?.lname ?? ''
  }`.trim(),
  contributors: [
    `${experiment?.campaignOwner?.fname?.slice(0, 1) ?? ''}${
      experiment?.campaignOwner?.lname?.slice(0, 1) ?? ''
    }`.trim(),
  ],
  contentType: experiment?.campaign_configuration?.distribution_channel ?? '',
})

const useGetExperimentsQuery = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const getExperimentsQuery = useQuery(
    personalizationKeys.experiments(accountId),
    () => fetchActivePersonalizedCampaigns(accountId),
    {
      select: (data) => data.campaigns.map(mapExperimentToCard),
    }
  )

  return getExperimentsQuery
}

export default useGetExperimentsQuery
